export const API_PATHS = {
  auth: {
    loginPath:           '/v1/auth/login',
    refreshPath:         '/v1/auth/refresh-token',
    logoutPath:          '/v1/auth/logout',
    forgotPasswordPath:  '/v1/auth/forgot-password',
    changePasswordPath:  '/v1/auth/change-password',
    resetPasswordPath:   '/v1/auth/reset-password',
    publicPaths: ['/v1/auth/login', '/v1/auth/refresh-token', '/v1/auth/forgot-password', '/v1/auth/reset-password'],
  },
  lookup: {
    allPath: '/v1/lookup/all',
  },
  providers: {
    getProviderPath:                  '/v1/providers/getProvider',
    getProviderByIdPath:              '/v1/providers/getProviderById',
    getStatePath:                     '/v1/providers/getState',
    sendEmailVerifyPath:              '/v1/providers/sendEmailVerify',
    getSelectedProviderDocumentsPath: '/v1/providers/getSelectedProviderDocuments',
    addEcmProviderAndDocumentsPath:   '/v1/providers/addEcmProviderAndDocuments',
    deleteProviderDocumentPath:       '/v1/providers/deleteProviderDocument',
    viewInviteProviderDocumentsPath:  '/v1/providers/viewInviteProviderDocuments',
  },
  users: {
    searchPath:       '/v1/users/search',
    basePath:         '/v1/users',
    userAccountsPath: '/v1/users',   // usage: `${userAccountsPath}/${userId}/accounts`
    accountsPath:     '/v1/accounts',
    rolesPath:        '/v1/roles',
    groupsPath:       '/v1/groups',
  },
  authorization: {
    getListPath: '/v1/authorizations/getPatientAuthorizationRequestList',
    addEditPath: '/v1/authorizations/addEditPatientAuthorizationCP',
  },
  common: {
    getPayorPath:    '/v1/common/getPayor',
    getProviderPath: '/v1/common/getProvider',
    getFacilityPath: '/v1/common/getFacility',
  },
  facesheet: {
    pendingPath:      '/v1/facesheets/pending',
    processedPath:    '/v1/facesheets/processed',
    uploadSinglePath: '/v1/facesheets/upload/single',
  },
  writeOff: {
    getClaimWriteoffPath:     '/v1/write-offs/getClaimWriteoff',
    addBulkClaimWriteOffPath: '/v1/write-offs/addBulkClaimWriteOff',
    getAdjustmentPath:        '/v1/write-offs/getAdjustment',
  },
};
